// Application configuration
export const config = {
  // API configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE || 'https://simplepos-worker.thierry-yge.workers.dev/api',
  },
  
  // Currency configuration
  currency: {
    code: 'EUR', // Default currency code
    symbol: '€', // Default currency symbol
    position: 'after' as 'before' | 'after', // Currency symbol position
    decimalPlaces: 2, // Number of decimal places
    thousandSeparator: ',', // Thousands separator
    decimalSeparator: '.', // Decimal separator
  },

  // Available currencies
  currencies: {
    EUR: {
      code: 'EUR',
      symbol: '€',
      position: 'after' as const,
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.',
    },
    CHF: {
      code: 'CHF',
      symbol: 'CHF',
      position: 'before' as const,
      decimalPlaces: 2,
      thousandSeparator: "'",
      decimalSeparator: '.',
    },
    USD: {
      code: 'USD',
      symbol: '$',
      position: 'before' as const,
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.',
    },
    GBP: {
      code: 'GBP',
      symbol: '£',
      position: 'before' as const,
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.',
    },
  },

  // App settings
  app: {
    name: 'SimplePOS',
    version: '1.0.0',
    defaultTab: 'pos' as 'pos' | 'orders' | 'products',
  },

  // UI settings
  ui: {
    theme: 'light' as 'light' | 'dark',
    language: 'en',
    dateFormat: 'en-US',
    timeFormat: 'en-US',
  },
};

// Currency formatting utility
export function formatCurrency(amount: number, currencyCode?: string): string {
  const currency = currencyCode ? config.currencies[currencyCode as keyof typeof config.currencies] : config.currency;
  
  if (!currency) {
    return amount.toFixed(2);
  }

  const formattedAmount = amount.toLocaleString(undefined, {
    minimumFractionDigits: currency.decimalPlaces,
    maximumFractionDigits: currency.decimalPlaces,
  });

  if (currency.position === 'before') {
    // Add space for CHF, no space for other currencies like $ and £
    const separator = currency.code === 'CHF' ? ' ' : '';
    return `${currency.symbol}${separator}${formattedAmount}`;
  } else {
    return `${formattedAmount}${currency.symbol}`;
  }
}

// Get current currency configuration
export function getCurrentCurrency() {
  return config.currency;
}

// Set currency configuration
export function setCurrency(currencyCode: keyof typeof config.currencies) {
  if (config.currencies[currencyCode]) {
    config.currency = { ...config.currencies[currencyCode] };
    // Save to localStorage for persistence
    localStorage.setItem('simplepos-currency', currencyCode);
    return true;
  }
  return false;
}

// Load currency from localStorage on app start
export function loadCurrencyFromStorage() {
  const savedCurrency = localStorage.getItem('simplepos-currency');
  if (savedCurrency && config.currencies[savedCurrency as keyof typeof config.currencies]) {
    config.currency = { ...config.currencies[savedCurrency as keyof typeof config.currencies] };
  }
}
